import { render, staticRenderFns } from "./AddStock.vue?vue&type=template&id=0af7aedd&scoped=true"
import script from "./AddStock.vue?vue&type=script&lang=js"
export * from "./AddStock.vue?vue&type=script&lang=js"
import style0 from "./AddStock.vue?vue&type=style&index=0&id=0af7aedd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af7aedd",
  null
  
)

export default component.exports